import * as z from "zod/v4";

export const getLegacySignedOAuthState = {
  name: "getLegacySignedOAuthState" as const,
  input: z.object({ extra: z.record(z.string(), z.string()).optional() }),
  output: z.object({ teamId: z.string(), signedState: z.string() }),
};
